/**
 * @ignore
 * User: daletan
 * Date: 3/21/16
 * Time: 12:35 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */

'use strict';

const uri = require('./uri.es');

/**
 * @param {string} url
 * @private
 */
function throwError(url) {
    throw new Error(`options.url required. \`${url}\` with typeof \`${typeof url}\` was passed in`);
}

/**
 * Having a separate method the actual redirects
 * gives the ability to mock/spy on it
 * @param url
 * @private
 */
exports._doRedirect = function (url) {
    if (typeof url === 'string') {
        window.location.href = url;
    }
};

/**
 * @param {object} options
 * @param {string} options.url The url to redirect
 * @param {Array} [options.blacklistParams] An array of blacklisted query params to strip
 * @covers throwError
 */
exports.redirect = function (options) {
    options = options || {};
    let { url } = options;
    if (!url || typeof url !== 'string') {
        throwError(url);
    }
    if (Array.isArray(options.blacklistParams) && options.blacklistParams.length) {
        url = uri.createCleanUrl(options);
    }
    exports._doRedirect(url);
};



// WEBPACK FOOTER //
// ./~/bunsen/helpers/http.es.js